// extracted by mini-css-extract-plugin
export default {"container":"S02_Summary_container__a0oxi","bottom":"S02_Summary_bottom__OMNCZ","limiter":"S02_Summary_limiter__R1GDI","wrapper":"S02_Summary_wrapper__3w7yt"};